"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Accordion", {
    enumerable: true,
    get: function() {
        return Accordion;
    }
});
var Accordion = {
    baseStyle: {
        icon: {
            size: "l",
            color: "text-primary"
        },
        button: {
            px: "1rem",
            py: "0.5rem"
        },
        panel: {
            padding: "1rem",
            textStyle: "text-body-regular"
        },
        container: {
            borderColor: "ui-element-divider"
        }
    }
};
